import {SensorData} from "./model";

export function getWindowData(arr: Array<SensorData>, index: number, windowSize = 5): Array<SensorData> {
  const startIndex = Math.max(0, index - windowSize)
  const endIndex = Math.min(arr.length, index + windowSize)

  return arr.slice(startIndex, endIndex)
}
